/**
 * Helpers de presentación del dominio Administración (traducción de error).
 *
 * Puro formato/traducción para la UI; sin lógica de negocio ni acceso a la API.
 */
import { ApiError } from "@/lib/api";

import { ADMIN_ERROR_MESSAGE } from "./constants";

/**
 * Traduce un error de la API/red a un mensaje legible.
 *
 * El backend (`domains/sedes.py`/`atendidos.py`/`export.py`) ya entrega mensajes
 * en español, específicos por dominio y a veces con dato dinámico (p. ej. el
 * conteo exacto de órdenes que bloquean el borrado de un atendido, o si lo que
 * está duplicado es una sede o un atendido). Por eso se **prioriza el `message`
 * del backend** cuando viene; el diccionario `ADMIN_ERROR_MESSAGE` queda como
 * **respaldo** para los casos sin mensaje útil (algunos errores de red/genéricos)
 * y se indexa por `error_code` (legible por máquina), no por texto.
 */
export function adminErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.message) {
      return error.message;
    }
    return ADMIN_ERROR_MESSAGE[error.error_code] ?? "Ocurrió un error al procesar la solicitud.";
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return "Ocurrió un error inesperado.";
}
